import React from 'react';
import { AsyncApiDefinitionWidget } from '../AsyncApiDefinitionWidget/AsyncApiDefinitionWidget.esm.js';
import { GraphQlDefinitionWidget } from '../GraphQlDefinitionWidget/GraphQlDefinitionWidget.esm.js';
import { OpenApiDefinitionWidget } from '../OpenApiDefinitionWidget/OpenApiDefinitionWidget.esm.js';
import { GrpcApiDefinitionWidget } from '../GrpcApiDefinitionWidget/GrpcApiDefinitionWidget.esm.js';
import { TrpcApiDefinitionWidget } from '../TrpcDefinitionWidget/TrpcApiDefinitionWidget.esm.js';

function defaultDefinitionWidgets() {
  return [
    {
      type: "openapi",
      title: "OpenAPI",
      rawLanguage: "yaml",
      component: (definition) => /* @__PURE__ */ React.createElement(OpenApiDefinitionWidget, { definition })
    },
    {
      type: "asyncapi",
      title: "AsyncAPI",
      rawLanguage: "yaml",
      component: (definition) => /* @__PURE__ */ React.createElement(AsyncApiDefinitionWidget, { definition })
    },
    {
      type: "graphql",
      title: "GraphQL",
      rawLanguage: "graphql",
      component: (definition) => /* @__PURE__ */ React.createElement(GraphQlDefinitionWidget, { definition })
    },
    {
      type: "grpc",
      title: "gRPC",
      component: (definition) => /* @__PURE__ */ React.createElement(GrpcApiDefinitionWidget, { definition })
    },
    {
      type: "trpc",
      title: "tRPC",
      component: (definition) => /* @__PURE__ */ React.createElement(TrpcApiDefinitionWidget, { definition })
    }
  ];
}

export { defaultDefinitionWidgets };
//# sourceMappingURL=ApiDefinitionWidget.esm.js.map
